<template>
	<div>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="inputTask" placeholder="请输入任务单号" prefix-icon="el-icon-search" size="small"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" @click="Find" icon="el-icon-search">搜索</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 99%;" align="center" max-height="600">
		    <el-table-column prop="serial_number" label="单号"></el-table-column>
		    <el-table-column prop="count" label="数量"></el-table-column>
		    <el-table-column prop="product" label="产品"></el-table-column>
		    <el-table-column prop="edition" label="版本"></el-table-column>
<!--		    <el-table-column prop="post_date" label="生成时间" :formatter="dateFormat"></el-table-column>-->
		    <el-table-column label="操作" width="100">
		    	<template slot-scope="scope">
		    		<el-button type="primary" size="mini" @click="GodownCode(scope.$index,scope.row)">二维码</el-button>
		    	</template>
		    </el-table-column>
  		</el-table>
  		
  		<!--工具条-->
  		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		
		<el-dialog title="下载二维码" :visible.sync="QrcodeVisible" :fullscreen="true">
			<el-button type="warning" style="margin-bottom: 10px;" @click="DownAll">打包下载此单所有设备二维码</el-button>
			<el-table :data="List2" border v-loading="listloading2" @selection-change="selsChange">
			    <el-table-column type="selection" width="50" :selectable='checkboxInit' prop='download_count'></el-table-column>
				<el-table-column label="流水号" prop="sid"></el-table-column>
				<!--<el-table-column label="操作" width="80">
					<template slot-scope="scope">
						<el-button v-if="scope.row.is_download == '是'" size="small" type="primary" disabled>已下载</el-button>   
					    <el-button v-if="scope.row.is_download == '否'" size="small" type="primary" @click="DownloadSingle(scope.$index,scope.row)">下载</el-button>        
					</template>
				</el-table-column>-->
  			</el-table>
  		
  			<el-col :span="24" class="toolbar">
  				<el-button type="primary" :disabled="this.sels.length === 0"  @click="Download" size="small">点击下载</el-button>
				<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange2" :page-size="Pagesize2" :current-page="Curpage2" :total="total2" style="float:right;">
				</el-pagination>
			</el-col>
		</el-dialog>
	</div>
</template>

<script>
	import {GetTasklist} from '../api/api';
	
	export default {
		data(){
			return{
				token:"",
				inputTask:"",
				List:[],
				listloading:false,
				total:1,
				Curpage:1,
				Pagesize:20,
				listloading2:false,
				QrcodeVisible:false,
				List2:[],
				total2:1,
				Curpage2:1,
				Pagesize2:20,
				sels:[],
				Form:{
					id:""
				}
			}
		},
		methods:{
			GodownCode(index,row){
				this.Curpage2 = 1
				this.listloading2 = true
				this.Form = Object.assign({}, row);
				this.QrcodeVisible = true
				let url = "/tasks/" + this.Form.id
				this.axios.get(url,{
					params:{
						token:this.token,
						expand:"devices"
					}
				}).then(res => {
					if(res.status == "200"){
						this.List2 = res.data.devices
						this.total2 = res.data.count
						this.listloading2 = false
					}else{
						this.$message.error('对不起，请求失败。')
					}
				}).catch(err => {
					this.$message.error(err.response.data.message)
				})
			},
			selsChange(sels){
				this.sels = sels;
			},
			checkboxInit(row,index){
				if (row.is_download == '否') {
					return 1;//可勾选
				}else{
					return 0;//不可勾选
				}
			},
			Find(){
				if(this.inputTask){
					this.GetList(GetTasklist,{page:this.Curpage,token:this.token,q:{"AND":{"serial_number":this.inputTask}}})
				}
			},
			Refresh(){
				this.inputTask = ""
				this.Curpage = 1
				this.GetList(GetTasklist,{page:this.Curpage,token:this.token})
			},
			handleCurrentChange(val){
				this.Curpage = val
				if(this.inputTask){
					this.GetList(GetTasklist,{page:this.Curpage,token:this.token,q:{"AND":{"serial_number":this.inputTask}}})
				}else{
					this.GetList(GetTasklist,{page:this.Curpage,token:this.token})
				}
			},
			download(src) {
			    var $a = $("<a></a>").attr("href", src).attr("download", "Code.zip");
			    $a[0].click();
			},
			handleCurrentChange2(val){
				this.Curpage2 = val
				let url = "/tasks/" + this.Form.id
				this.axios.get(url,{
					params:{
						token:this.token,
						page:this.Curpage2,
						expand:"devices"
					}
				}).then(res => {
					if(res.status == "200"){
						this.List2 = res.data.devices
						this.total2 = res.data.count
						this.listloading2 = false
					}else{
						this.$message.error('对不起，请求失败。')
					}
				}).catch(err => {
					this.$message.error(err.response.data.message)
				})
			},
			Download(index,row){
				var sids = this.sels.map(item => item.sid.slice(9,12)); 
				sids = (sids+"").replace(/\[|]/g,'')
				console.log(sids)
//				let url = "/tasks/" + this.Form.id + "/qrcodes"
				let url = "http://bk.bangbangrobotics.com/tasks/" + this.Form.id + "/qrcodes?token=" + this.token + "&sids=" + sids
//				+ this.token + "&sids=" + sids
//				console.log(url)
				location.href = url
//				this.axios.get(url,{
//					params:{
//						token:this.token,
//						sids:sids
//					}
//				}).then(res => {
//					console.log("res",res)
//				}).catch(err =>{
//					console.log(err)
//				})
			},
			DownAll(){
				let url = "http://bk.bangbangrobotics.com/tasks/" + this.Form.id + "/qrcodes?token=" + this.token
				location.href = url
			}
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.GetList(GetTasklist,{page:this.Curpage,token:this.token})
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// QRcodeDown.vue?044c4b97